<div class="row">
    <div class="col-md-12">
        <div class="related-items">
            <div class="title-box">
                <h2 class="text-primary">Customers Also Viewed</h2>
            </div>
            <div class="recommendations-container">
            <swiper-container class="recommendations-carousel" appSwiper [slideData]="recommendations" [shouldLoop]="true" #swiper>
                    <swiper-slide *ngFor="let recommendation of recommendations">
                        <app-product-card 
                            [product]="recommendation"
                            class="recommendations-swiper-product"
                            (addedToCart)="addedToCart.emit($event)"
                            [source]="source">
                        </app-product-card>
                    </swiper-slide>
                </swiper-container>
            </div>
        </div>
    </div>
</div>